module.exports = __webpack_public_path__ + "static/media/user.d63e59a7.svg";